var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nio-image"},[(!_vm.isNoneImg)?_c('img',{staticClass:"nio-image-pic",class:{ 'loading': _vm.isImgLoading },attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":_vm.onImgLoad}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5c14b0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/marketing_components/img-loader.vue
// module id = 242
// module chunks = 11